import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const NotesFromBuyer = {
  id: 'notesFromBuyer',
  displayName: <FormattedMessage {...messages.notesFromBuyer} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'NotesFromBuyer',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
